module Client.Admin.UserInfoSections.ActiveUsers

open Client
open Elmish
open Shared.Admin.UserInfo
open Illy.SafeStack.Client
open Shared
open Fable.React
open Fable.React.Props
open Illy.SafeStack.Client.jQueryUI

type Model =
    {
        Users: UserActivity list
        Loading: bool
    }

type Msg =
    | LoadedUsers of UserActivity list
    | ApiError of ApiError
    | CloseOverlay

type Event =
    | ApiError of ApiError
    | CloseOverlay

let init() =
    {
        Loading = true
        Users = []
    }, Cmd.none

let showGrid model =
    {
        model with
            Loading = true
    }, Api.secureCall<IUserInfoApi,_,_,_> SecuredRoute.Admin (fun api -> api.get50MostActiveUsers) () LoadedUsers Msg.ApiError

let update msg model =
    match msg with
    | Msg.CloseOverlay -> model, CloseOverlay |> SideEffect.Event
    | Msg.ApiError err -> model, err |> ApiError |> SideEffect.Event
    | LoadedUsers users ->
        {
            model with
                Loading = false
                Users = users
        }, SideEffect.none

let view (model: Model) dispatch =
    jQueryUI.modal
        "The 50 most active users"
        2500
        Msg.CloseOverlay
        dispatch
        (Some 1000)
        [
            yield jQueryUI.simpleTable 
                "No users found."
                [
                    Some [ str "Name" ] ===> fun (x: UserActivity) -> [ 
                        str x.Forename 
                        str " " 
                        str x.Surname 
                    ]
                    Some [ str "Username" ] ===> fun (user: UserActivity) -> [ str user.Username ]
                    Some [ str "Number of logins" ] ===> fun (user: UserActivity) -> [ str <| user.NumberOfLogins.ToString() ]
                ]
                model.Loading
                model.Users
        ]
